<aside
  [ngClass]="{ open: open }"
  class="bg-white border-end moalaa_aside position-relative"
>
  <div (click)="toggle()" class="close_btn">
    <span *ngIf="open" class="bx bx-x"></span>
    <span *ngIf="!open" class="isax-category-2"></span>
  </div>
  <ngx-simplebar class="position-absolute p-3 start-0 top-0 w-100 h-100">
    <ng-content></ng-content>
  </ngx-simplebar>
</aside>
